import { render, staticRenderFns } from "./scancode.vue?vue&type=template&id=619eec46&"
import script from "./scancode.vue?vue&type=script&lang=js&"
export * from "./scancode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports